<template>
  <div id="contenedor-main-contrato-reporte-fisico">
    <div class="white rounded-xl">
      <!-- <div
        class="py-5 text-center">
        <h1>
          ORGANIZACIÓN
        </h1>
        <h4>
          SISTEMA DE CONTROL DE CONTRATOS DE OBRA PÚBLICA
        </h4>
      </div> -->
      <v-row no-gutters class="text-center mb-5">
        <v-col md="4">
          <v-row>
            <v-col cols="12" class="base4 titulo-reporte">
              CONTRATO / CONVENIO
            </v-col>
            <v-col cols="12">
              {{ getContrato.numero }}
            </v-col>
          </v-row>
        </v-col>
        <v-col md="4">
          <v-row>
            <v-col cols="12" class="base4 titulo-reporte"> CONTRATISTA </v-col>
            <v-col cols="12">
              {{ getContrato.contratista.nombreRazonSocial }}
            </v-col>
          </v-row>
        </v-col>
        <v-col md="4">
          <v-row>
            <v-col cols="12" class="base4 titulo-reporte"> RESIDENTE </v-col>
            <v-col cols="12"> Residente </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- Importes, Superintendentes, Supervision externa -->
      <v-row no-gutters class="text-center mb-5">
        <v-col md="4">
          <v-row>
            <v-col cols="12" class="base4 titulo-reporte"> IMPORTES </v-col>
            <v-col md="4">
              <v-row>
                <v-col cols="12" class="base5 titulo-reporte"> CONTRATO </v-col>
                <v-col cols="12">
                  {{ getContrato.importe | currency }}
                </v-col>
              </v-row>
            </v-col>
            <v-col md="4">
              <v-row>
                <v-col cols="12" class="base5 titulo-reporte">
                  CONVENIOS
                </v-col>
                <v-col cols="12">
                  {{ 0 | currency }}
                </v-col>
              </v-row>
            </v-col>
            <v-col md="4">
              <v-row>
                <v-col cols="12" class="base5 titulo-reporte">
                  TOTAL CONTRATO
                </v-col>
                <v-col cols="12">
                  {{ getContrato.importe | currency }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="4">
          <v-row>
            <v-col cols="12" class="base4 titulo-reporte">
              SUPERINTENDENTE
            </v-col>
            <v-col cols="12"> N/A </v-col>
          </v-row>
        </v-col>
        <v-col md="4">
          <v-row>
            <v-col cols="12" class="base4 titulo-reporte">
              SUPERVISIÓN EXTERNA
            </v-col>
            <v-col cols="12"> N/A </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- Fechas y Avances -->
      <v-row no-gutters class="text-center">
        <!-- Fechas -->
        <v-col md="6">
          <v-row no-gutters>
            <v-col md="6">
              <v-row>
                <v-col cols="12" class="base4 titulo-reporte">
                  FECHA INICIO
                </v-col>
                <v-col cols="12">
                  {{ getContrato.fechaInicio }}
                </v-col>
              </v-row>
            </v-col>
            <v-col md="6">
              <v-row>
                <v-col cols="12" class="base4 titulo-reporte">
                  FECHA INICIO CONVENIDA
                </v-col>
                <v-col cols="12"> N/A </v-col>
              </v-row>
            </v-col>
            <v-col md="6">
              <v-row>
                <v-col cols="12" class="base4 titulo-reporte">
                  FECHA TERMINO
                </v-col>
                <v-col cols="12">
                  {{ getContrato.fechaTermino }}
                </v-col>
              </v-row>
            </v-col>
            <v-col md="6">
              <v-row>
                <v-col cols="12" class="base4 titulo-reporte">
                  FECHA TÉRMINO CONVENIDA
                </v-col>
                <v-col cols="12"> N/A </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <!-- Avances -->
        <v-col md="6">
          <v-row justify="center">
            <v-col cols="12" class="base4 titulo-reporte">
              AVANCE A LA FECHA
            </v-col>
            <v-col cols="12" md="4">
              <v-row>
                <v-col cols="12" class="base5 titulo-reporte">
                  PROGRAMADO
                </v-col>
                <v-col cols="12" class="blue lighten-5 display-3">
                  {{ reporteFisico.avanceProgramado }}%
                </v-col>
              </v-row>
            </v-col>
            <!-- <v-col
              md="4">
              <v-row>
                <v-col
                  cols="12"
                  class="base5 titulo-reporte">
                  FINANCIERO
                </v-col>
                <v-col
                  cols="12"
                  class="amber lighten-4 display-3">
                  {{ reporteFisico.avanceFinanciero }}%
                </v-col>
              </v-row>
            </v-col> -->
            <v-col md="4">
              <v-row>
                <v-col cols="12" class="base5 titulo-reporte"> FÍSICO </v-col>
                <v-col cols="12" class="light-green lighten-4 display-3">
                  {{ reporteFisico.avanceFisico }}%
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div class="white rounded-xl mt-5">
      <div>
        <v-row class="py-5">
          <v-col cols="12" md="6" class="titulo-reporte text-center">
            COMENTARIOS GENERALES DEL REPORTE
          </v-col>
          <v-col
            cols="12"
            md="6"
            :class="reporteFisico.existeProblema
                ? 'titulo-reporte-rojo text-center'
                : 'titulo-reporte text-center'">
            PROBLEMÁTICA
          </v-col>
          <v-col cols="12" md="6">
            <v-card class="base5 fill-height" style="border-radius: 8px" flat>
              <v-card-text>
                {{ reporteFisico.comentarios }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card
              v-if="reporteFisico.existeProblema"
              class="contenedor-rojo fill-height"
              style="border-radius: 8px"
              flat
            >
              <v-card-text style="color: white">
                {{ reporteFisico.descripcionProblema }}
              </v-card-text>
            </v-card>
            <v-card
              v-else
              class="base5 fill-height"
              style="border-radius: 8px"
              flat
            >
              <v-card-text>
                No hay problemática registrada.
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div v-for="partida in reporteFisico.partidas" :key="partida.id">
        <v-row>
          <v-col
            class="
              text-start
              base4
              subtitle-1
              font-weight-bold
              titulo-reporte
              pl-5
            "
          >
            {{ partida.partida.concepto }}
            {{ partida.avanceFisico }}%
          </v-col>
          <v-col
            class="
              text-end
              base4
              subtitle-1
              font-weight-bold
              titulo-reporte
              pr-5
            "
          >
            INFORME FOTOGRÁFICO
          </v-col>
          <v-col cols="12" class="pl-5">
            {{ partida.comentario }}
          </v-col>
        </v-row>
        <v-row :key="`imagenes-${partida.id}`" justify="start">
          <v-col v-for="img in partida.imagenes" :key="img.id" md="2">
            <v-img
              :src="`${$urlFileServer}/${img}/thumbnail`"
              max-width="150"
              max-height="150"
            >
            </v-img>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';

export default {
  name: 'MainContratoReporteFisico',
  components: {},
  props: {
    reporteFisico: Object,
  },
  data() {
    return {};
  },
  methods: {},
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getReporteFisico() {
      if (!this.reporteFisico) return {};
      return this.reporteFisico;
    },
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
  },
};
</script>

<style lang="scss" scoped>
.titulo-reporte {
  font-weight: bold;
  font-size: 15px;
  color: #05053e !important;
}
.titulo-reporte-rojo {
  font-weight: bold;
  font-size: 15px;
  color: #d32f2f !important;
}
.contenedor-rojo {
  background: #e53935;
}
</style>
